<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <div class="nav-bottom">
        <div class="footerInfo w1260">
          <div class="top auroraBenefitBar">
             <div class="benefitItem">
               <span class="benefitNeonIcon neonGiftIcon" aria-hidden="true">
                 <svg viewBox="0 0 64 64">
                   <path d="M13 25h38v31H13z"></path>
                   <path d="M32 25v31"></path>
                   <path d="M9 17h46v8H9z"></path>
                   <path d="M32 17c-5-14-20-13-20-3 0 9 20 3 20 3z"></path>
                   <path d="M32 17c5-14 20-13 20-3 0 9-20 3-20 3z"></path>
                   <path d="M13 40h38"></path>
                 </svg>
               </span>
               <p>
                 <strong>다양한 이벤트</strong>
                 <em>풍성한 혜택</em>
               </p>
             </div>
             <div class="benefitItem">
               <span class="benefitNeonIcon neonTrophyIcon" aria-hidden="true">
                 <svg viewBox="0 0 64 64">
                   <path d="M21 12h22v18c0 8-5 14-11 14s-11-6-11-14V12z"></path>
                   <path d="M21 18h-8v7c0 6 4 10 10 10"></path>
                   <path d="M43 18h8v7c0 6-4 10-10 10"></path>
                   <path d="M32 44v8"></path>
                   <path d="M22 56h20"></path>
                   <path d="M26 52h12"></path>
                   <path d="M32 20l2 4 5 .5-3.5 3 1 5-4.5-2.5-4.5 2.5 1-5-3.5-3 5-.5 2-4z"></path>
                 </svg>
               </span>

               <p>
                 <strong>VIP 전용 서비스</strong>
                 <em>특별한 경험</em>
               </p>
             </div>
             <div class="benefitLogo">
               <img src="@/assets/img/footer_aurora.png" alt="AURORA">
             </div>
             <div class="benefitItem">
               <span class="benefitNeonIcon neonShieldIcon" aria-hidden="true">
                 <svg viewBox="0 0 64 64">
                   <path d="M32 6l20 8v15c0 14-8 23-20 29C20 52 12 43 12 29V14l20-8z"></path>
                   <path d="M23 31l6 6 13-15"></path>
                   <path d="M32 13l13 5v11c0 9-5 16-13 21-8-5-13-12-13-21V18l13-5z"></path>
                 </svg>
               </span>
               <p>
                 <strong>안전한 보안</strong>
                 <em>24시간 보호</em>
               </p>
             </div>
             <div class="benefitItem">
               <span class="benefitNeonIcon neonHeadsetIcon" aria-hidden="true">
                 <svg viewBox="0 0 64 64">
                   <path d="M14 35v-6c0-11 8-20 18-20s18 9 18 20v6"></path>
                   <path d="M14 34h6v14h-6c-3 0-5-2-5-5v-4c0-3 2-5 5-5z"></path>
                   <path d="M44 34h6c3 0 5 2 5 5v4c0 3-2 5-5 5h-6V34z"></path>
                   <path d="M50 48c0 5-4 8-10 8h-4"></path>
                   <path d="M31 56h5"></path>
                   <path d="M36 56c0 2-2 4-4 4s-4-2-4-4 2-4 4-4 4 2 4 4z"></path>
                 </svg>
               </span>
               <p>
                 <strong>고객센터</strong>
                 <em>빠른 상담</em>
               </p>
             </div>
          </div>
          <div class="bottom">
            <img src="@/assets/img/footer-img.png" />
          </div>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped>
.footerInfo ul li{cursor: pointer;}
</style>
